import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-653ad3aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-cont" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-headline" }, " Möchtest du Zusatzoptionen dazubuchen? ", -1))
const _hoisted_3 = { class: "form-fields" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-headline" }, " 1. Auswahl Deines Routers ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-headline" }, " 2. IP-Netz ", -1))
const _hoisted_6 = { class: "form-headline" }
const _hoisted_7 = { class: "form-headline" }

import Product from '@/classes/Product';
import BaseGridCol from '@/components/BaseGridCol.vue';
import BaseGridRow from '@/components/BaseGridRow.vue';
import AppRadioCardButtons from '@/components/inputs/AppRadioCardButtons.vue';
import AppOrderActions from '@/components/order/order/AppOrderActions.vue';
import { formatNumber } from '@/helpers';
import TelevisionPackageInterface from '@/interfaces/TelevisionPackageInterface';
import { computed } from 'vue';
import TelevisionProducts from '../../../../public/TelevisionProducts.json';


export default /*#__PURE__*/_defineComponent({
  __name: 'InternetConfigOptions',
  props: /*#__PURE__*/_mergeModels({
    product: {},
    priceParams: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(['previous', 'next'], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;

const form = _useModel<Record<string, any>>(__props, "modelValue");
const emit = __emit;

const routers = TelevisionProducts.router as TelevisionPackageInterface[];
const services = TelevisionProducts.services as TelevisionPackageInterface[];
const ipNetworks = TelevisionProducts.ipNetworks as TelevisionPackageInterface[];
const flatrates = TelevisionProducts.flatrates as TelevisionPackageInterface[];
const customerType = props.priceParams?.customerType || 'private';
const getMonthlyBasePrice = (item: TelevisionPackageInterface) => item.price?.recurring?.find((recurringPrice) => recurringPrice?.type === 'base_price')?.value || 0;
const getMonthlyBasePriceFormatted = (item: TelevisionPackageInterface) => formatNumber(getMonthlyBasePrice(item), 2);
const getOneTimeBasePrice = (item: TelevisionPackageInterface) => item.price?.oneTime?.find((recurringPrice) => recurringPrice?.type === 'base_price')?.value || 0;
const getOneTimeBasePriceFormatted = (item: TelevisionPackageInterface) => formatNumber(getOneTimeBasePrice(item), 2);

const routerOptions = routers.map((router) => ({
  value: router.id,
  label: `${getMonthlyBasePrice(router) > 0 ? '+' : ''}${getMonthlyBasePriceFormatted(router)}&thinsp;€/Monat`,
  description: router.name,
  hint: router.hint,
  customerType: router.customerType,
})).filter((option) => !Array.isArray(option.customerType) || option.customerType.includes(customerType));
const flatrateOptions = flatrates.map((flatrate) => {
  let flatrateToUse = flatrate;

  if (flatrateToUse?.isTariffConditional) return undefined;
  if (flatrateToUse?.tariffCondition) {
    if (props.product.name.trim().toLowerCase().startsWith(flatrateToUse.tariffCondition.tariff.toLowerCase())) {
      const flatrateToReplaceBy = flatrates.find((s) => s.id === flatrateToUse.tariffCondition?.replaceBy);

      if (flatrateToReplaceBy) {
        flatrateToUse = flatrateToReplaceBy;
      }
    }
  }

  return {
    value: flatrateToUse.id,
    label: `${getMonthlyBasePrice(flatrateToUse) > 0 ? '+' : ''}${getMonthlyBasePriceFormatted(flatrateToUse)}&thinsp;€/Monat`,
    description: flatrateToUse.name,
    fixed: flatrateToUse.id === 'flat-1',
    excludes: flatrateToUse.price.excludes,
    customerType: flatrateToUse.customerType,
  };
}).filter((option) => !!option && (!Array.isArray(option.customerType) || option.customerType.includes(customerType)));
const serviceOptions = services.map((service) => {
  const hasMonthly = getMonthlyBasePrice(service) > 0;
  const price = hasMonthly ? getMonthlyBasePrice(service) : getOneTimeBasePrice(service);
  const priceFormatted = hasMonthly ? `${getMonthlyBasePriceFormatted(service)}&thinsp;€/Monat` : `${getOneTimeBasePriceFormatted(service)}&thinsp;€`;

  return {
    value: service.id,
    label: `${price > 0 ? '+' : ''}${priceFormatted}`,
    description: service.name,
    excludes: service.price.excludes,
    customerType: service.customerType,
    fixed: customerType === 'business' && service.id === 'service-1',
  };
}).filter((option) => !!option && (!Array.isArray(option.customerType) || option.customerType.includes(customerType)));
const ipOptions = ipNetworks.map((ip) => ({
  value: ip.id,
  label: `${getOneTimeBasePrice(ip) > 0 ? '+' : ''}${getMonthlyBasePriceFormatted(ip)}&thinsp;€/Monat`,
  description: ip.name,
  excludes: ip.price.excludes,
  customerType: ip.customerType,
})).filter((option) => !Array.isArray(option.customerType) || option.customerType.includes(customerType));

const hasAdditionalOptions = computed(() => {
  if (form.value?.addons?.router !== routerOptions[0].value) return true;
  if ((form.value?.addons?.flatrates || []).length > 1) return true;
  if ((form.value?.addons?.ipNetworks || []).length > 1) return true;
  if ((form.value?.addons?.services || []).length >= 1 && (form.value?.addons?.services || []).join() !== 'service-1') return true;

  return false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(BaseGridRow, { "no-gap": "" }, {
        default: _withCtx(() => [
          _createVNode(BaseGridCol, null, {
            default: _withCtx(() => [
              _createVNode(BaseGridRow, { small: "" }, {
                default: _withCtx(() => [
                  _createVNode(BaseGridCol, null, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(BaseGridCol, null, {
                    default: _withCtx(() => [
                      _createVNode(AppRadioCardButtons, {
                        class: "mb-0",
                        modelValue: form.value.addons.router,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.addons.router) = $event)),
                        options: _unref(routerOptions),
                        "grid-template": {
                    xs: '1fr',
                    sm: '1fr 1fr',
                    md: '1fr 1fr 1fr',
                    lg: '1fr 1fr',
                    xxl: '1fr 1fr 1fr',
                  }
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_unref(ipOptions).length)
            ? (_openBlock(), _createBlock(BaseGridCol, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(BaseGridRow, { small: "" }, {
                    default: _withCtx(() => [
                      _createVNode(BaseGridCol, null, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }),
                      _createVNode(BaseGridCol, null, {
                        default: _withCtx(() => [
                          _createVNode(AppRadioCardButtons, {
                            class: "mb-0",
                            modelValue: form.value.addons.ipNetworks,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.addons.ipNetworks) = $event)),
                            options: _unref(ipOptions),
                            multiple: "",
                            "grid-template": {
                    xs: '1fr',
                    sm: '1fr 1fr',
                    md: '1fr 1fr 1fr',
                    lg: '1fr 1fr',
                    xxl: '1fr 1fr 1fr',
                  }
                          }, null, 8, ["modelValue", "options"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(BaseGridCol, null, {
            default: _withCtx(() => [
              _createVNode(BaseGridRow, { small: "" }, {
                default: _withCtx(() => [
                  _createVNode(BaseGridCol, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(ipOptions).length ? 3 : 2) + ". Flatrates ", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(BaseGridCol, null, {
                    default: _withCtx(() => [
                      _createVNode(AppRadioCardButtons, {
                        class: "mb-0",
                        modelValue: form.value.addons.flatrates,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.addons.flatrates) = $event)),
                        options: _unref(flatrateOptions),
                        multiple: "",
                        "grid-template": {
                    xs: '1fr',
                    sm: '1fr 1fr',
                    md: '1fr 1fr 1fr',
                    lg: '1fr 1fr',
                    xxl: '1fr 1fr 1fr',
                  }
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(BaseGridCol, null, {
            default: _withCtx(() => [
              _createVNode(BaseGridRow, { small: "" }, {
                default: _withCtx(() => [
                  _createVNode(BaseGridCol, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(ipOptions).length ? 4 : 3) + ". Service ", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(BaseGridCol, null, {
                    default: _withCtx(() => [
                      _createVNode(AppRadioCardButtons, {
                        class: "mb-0",
                        modelValue: form.value.addons.services,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.addons.services) = $event)),
                        options: _unref(serviceOptions),
                        multiple: "",
                        "at-least-one-of": ['service-1', 'service-2'],
                        "switch-excludes": "",
                        "grid-template": {
                    xs: '1fr',
                    sm: '1fr 1fr',
                    md: '1fr 1fr 1fr',
                    lg: '1fr 1fr',
                    xxl: '1fr 1fr 1fr',
                  }
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createVNode(AppOrderActions, {
        labels: {
            previous: 'Zurück',
            next: hasAdditionalOptions.value ? 'Weiter' : 'Ohne Zusatzoptionen weiter',
          },
        onPrevious: _cache[4] || (_cache[4] = ($event: any) => (emit('previous'))),
        onNext: _cache[5] || (_cache[5] = ($event: any) => (emit('next'))),
        "color-next": _ctx.product.branch,
        "hide-required-hint": ""
      }, null, 8, ["labels", "color-next"])
    ])
  ]))
}
}

})